import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Autoplay, Navigation, Pagination } from "swiper/modules"
import Lodash, { isEmpty } from "lodash";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
// components
import SliderLayouts from "./SliderLayouts";
// actions
import CoreAction from "core/actions/common/CoreAction";
import ClientSilderItemServiceAction from "cms/actions/components/Slider/ClientSilderItemServiceAction";
// interfaces
import IOdataQueryOptions from 'core/interfaces/IOdataQueryOptions';
// enums
import ELayoutTypeDataSource from "cms/enums/ELayoutType";
// 
import { getLocalDateTime } from "core/utilities/DateTimeHelper";
import IClientSliderItemList from "cms/interfaces/IClientSliderItemList";
//
import "swiper/css/bundle";
import { EContentStatus } from "cms/enums/EContentStatus";
import { Dispatch } from "@reduxjs/toolkit";
import IClientSiteSettingDetail from "cms/interfaces/IClientSiteSettingDetail";
import IClientLanguage from "core/interfaces/IClientLanguage";
import TValidations from "cms/types/TValidations";


function mapStateToProps ( state: any ) {
    console.log("Slider.mapStateToProps: ", state);

    const siteSettingDetailPayload:IClientSiteSettingDetail     = state.SiteSettingStore.details?.payload;

    const webApplicationLanguage: IClientLanguage               = state.CoreStore.language?.payload;
    const webApplicationLanguageCode: string                    = webApplicationLanguage.code;
    const webApplicationLanguageISOCode: string                 = state.CoreStore.languageCode?.payload;

    const sliderItemListPayload:IClientSliderItemList[]|null    = state.SliderStore.ClientSilderItemStore.list?.payload;
    const sliderItemListError:TValidations[]|null               = state.SliderStore.ClientSilderItemStore.list?.error;
    const sliderItemListIsLoading:boolean                       = state.SliderStore.ClientSilderItemStore.list?.isLoading;

    return {

        siteSettingDetailPayload,

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        sliderItemListPayload,
        sliderItemListError,
        sliderItemListIsLoading

    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("Slider.mapDispatchToProps");

    const coreAction = new CoreAction(dispatch);
    const clientSilderItemServiceAction = new ClientSilderItemServiceAction(dispatch);

    return {
        // list
        _listSliderItems: (categoryId: string, webApplicationLanguageCode: string) => {
            let queryOptions: IOdataQueryOptions = {
                filter: [`status eq ${EContentStatus.ACTIVE}`, "and", `(publishDate le ${getLocalDateTime()} or publishDate eq null)`, "and", `(expireDate ge ${getLocalDateTime(true)} or expireDate eq null)`],
                orderBy: ["order asc"],
                top: 1000
            };

            clientSilderItemServiceAction.list({ servicePayload: { queryOptions, language: webApplicationLanguageCode } });
        },

        // other
        _hideLoader: () => {
            coreAction.hideLoader();
        }
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>

type TSlider<T> = {

    layoutName?:string;

} & T;


/* component */
function SliderLoader () {

    return (
        <></>
    )

}

function Slider ( props: TSlider<PropsFromRedux> ) {
    console.log("Slider.rendered: ", props);

    const swiperOptions = {
        modules: [Autoplay, Pagination, Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: true,
        // },
        loop: true,
    
        // Navigation
        navigation: {
            nextEl: '.h1n',
            prevEl: '.h1p',
        },
    
        // Pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        // on: {
        //     transitionStart: function() {
        //         var videos = document.querySelectorAll('video');
        //         Array.prototype.forEach.call(videos, function(video){
        //             video.pause();
        //         });
        //     },
            
        //     transitionEnd: function(){
        //       var activeIndex = this.activeIndex;
        //       var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
        //       var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
        //       activeSlideVideo.play();
            
        //     },
          
        // }
    }

    useEffect(
        () => {
            if ( props.layoutName && !Lodash.isEmpty(props.layoutName)) {
                props._listSliderItems(props.layoutName, props.webApplicationLanguageCode);
            }
        }, [ props.layoutName ]
    )

    if (!isEmpty(props.sliderItemListPayload)) {

        return (
            <section className="main-slider-three">
                <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider" 
                    onTransitionEnd={(swiper: SwiperClass) => {
                        let videoItem = swiper.slides.find((item) => item.classList.contains("swiper-slide-active"));
                        let video = videoItem?.getElementsByTagName("video")?.[0];
                        if ( video ) video.play();
                    }}
                    onTransitionStart={(swiper: SwiperClass) => {
                        for ( let item of swiper.slides ) {
                            let video = item.getElementsByTagName("video")?.[0];
                            if ( video ) video.pause();
                        }
                    }}
                    onClick={(swiper: SwiperClass, event: MouseEvent | TouchEvent | PointerEvent) => {
                        for ( let item of swiper.slides ) {
                            let video = item.getElementsByTagName("video")?.[0];
                            if ( video && video.paused ) video.play();
                            else if ( video ) video.pause();
                        }
                    }}
                >
                    <div className="swiper-wrapper">
                        {
                            props.sliderItemListPayload?.map((item) => {
                                const layoutName = item.layouts?.[0]?.layoutName;
                                const Layout = SliderLayouts[layoutName]

                                if ( Layout ) {
                                    return <SwiperSlide><Layout payload={item} siteSettingPayload={props.siteSettingDetailPayload} /></SwiperSlide>
                                }
                                
                            })
                        }
                    </div>
                    <div className="main-slider-three__nav">
                        <div className="swiper-button-prev h1p" id="main-slider__swiper-button-next">
                            <i className="icon-arrow-left"></i>
                        </div>
                        <div className="swiper-button-next h1n" id="main-slider__swiper-button-prev">
                            <i className="icon-arrow-right"></i>
                        </div>
                    </div>
                </Swiper>
            </section>
        );

    }

    return null;

}

Slider.defaultProps = {

    layoutName: "SLDRGRP_001"

}

const Component = React.memo(Slider, ( prevProps: TSlider<PropsFromRedux>, nextProps: TSlider<PropsFromRedux> ) => {
    console.log("Slider.memo", { prevProps, nextProps });

    return !(
        prevProps.webApplicationLanguageISOCode !== nextProps.webApplicationLanguageISOCode
        || prevProps.sliderItemListPayload !== nextProps.sliderItemListPayload
    )
});

export default connector(Component);
